export default function WhoShouldUse() {
  const profiles = [
    {
      icon: 'ri-shopping-bag-3-line',
      title: '日常的に買い物をする方',
      description: 'スーパーやコンビニでの日常的な買い物が多い方は、基本還元率が高いカードを選ぶことで、毎日の支出からコツコツとポイントを貯められます。',
      recommendedCards: ['リクルートカード（1.2%）', '大手ECモール系カード（1%）'],
      benefit: '月10万円利用で年間12,000円以上の還元'
    },
    {
      icon: 'ri-store-2-line',
      title: '特定の店舗をよく使う方',
      description: 'セブン-イレブンやローソンなど、特定のコンビニや飲食店を頻繁に利用する方は、その店舗で高還元率になるカードを選ぶのがおすすめです。',
      recommendedCards: ['三井住友カード（NL）（最大7%）', 'JCB CARD W（最大5.5%）'],
      benefit: 'コンビニで月3万円利用で年間25,000円以上の還元'
    },
    {
      icon: 'ri-shopping-cart-2-line',
      title: 'ネットショッピングが多い方',
      description: 'ECモールやAmazonなどのネットショッピングを頻繁に利用する方は、そのモールで高還元率になるカードを選ぶことで大きくポイントを貯められます。',
      recommendedCards: ['大手ECモール系カード（ECモールで3%以上）', 'JCB CARD W（Amazon 2%）'],
      benefit: 'ECモールで月5万円利用で年間18,000円以上の還元'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'スマホ決済を使う方',
      description: 'd払いやスマホ決済などと組み合わせることで、さらに高い還元率を実現できます。キャッシュレス派におすすめです。',
      recommendedCards: ['dカード（d払い併用で2.5%）', '大手ECモール系カード（ペイ併用で1.5%）'],
      benefit: 'スマホ決済併用で還元率が1.5〜2倍にアップ'
    },
    {
      icon: 'ri-flight-takeoff-line',
      title: '旅行や出張が多い方',
      description: '旅行や出張で大きな支出がある方は、高還元率カードを使うことで一度に大量のポイントを獲得できます。',
      recommendedCards: ['リクルートカード（1.2%）', '三井住友カード（NL）（0.5%）'],
      benefit: '旅行費用20万円で2,400円以上の還元'
    },
    {
      icon: 'ri-wallet-3-line',
      title: '複数のカードを使い分けたい方',
      description: '用途に応じて複数のカードを使い分けることで、それぞれの強みを活かして最大限のポイント還元を受けられます。',
      recommendedCards: ['メインカード＋サブカード2枚', '店舗別に使い分け'],
      benefit: '最適な組み合わせで還元率を最大化'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            本当に得する人の特徴
          </h2>
          <p className="text-lg text-gray-600">
            あなたの利用スタイルに合った高還元率カードを見つけましょう
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {profiles.map((profile, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all border border-gray-200"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-14 h-14 bg-gradient-to-br from-[#FFB800] to-[#FFA000] rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className={`${profile.icon} text-white text-2xl`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{profile.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{profile.description}</p>
                </div>
              </div>

              <div className="space-y-3">
                <div className="bg-[#FFB800]/5 rounded-lg p-4 border border-[#FFB800]/20">
                  <div className="text-xs font-medium text-gray-500 mb-2">おすすめカード</div>
                  <div className="space-y-1">
                    {profile.recommendedCards.map((card, idx) => (
                      <div key={idx} className="flex items-center gap-2 text-sm font-medium text-gray-900">
                        <i className="ri-check-line text-[#FFB800]"></i>
                        <span>{card}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-green-50 rounded-lg p-4 border border-green-200">
                  <div className="flex items-start gap-2">
                    <i className="ri-money-dollar-circle-line text-green-600 text-lg flex-shrink-0 mt-0.5"></i>
                    <div>
                      <div className="text-xs font-medium text-gray-500 mb-1">期待できる還元額</div>
                      <div className="text-sm font-bold text-green-700">{profile.benefit}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-br from-[#FFB800] to-[#FFA000] rounded-xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">自分に合ったカードを見つけよう</h3>
          <p className="text-white/90 mb-6 max-w-2xl mx-auto">
            利用スタイルに合わせて最適なカードを選ぶことで、年間数万円のポイント還元を受けることができます。まずは自分の支出パターンを確認してみましょう。
          </p>
          <a
            href="#top-cards"
            className="inline-block bg-white text-[#FFB800] px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
          >
            おすすめカードを見る
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
